import { render, staticRenderFns } from "./FileDownloadNonberusaha.vue?vue&type=template&id=769b863c&scoped=true&"
import script from "./FileDownloadNonberusaha.vue?vue&type=script&lang=js&"
export * from "./FileDownloadNonberusaha.vue?vue&type=script&lang=js&"
import style0 from "./FileDownloadNonberusaha.vue?vue&type=style&index=0&id=769b863c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "769b863c",
  null
  
)

export default component.exports